import { IDonorStatus } from "./donor-status";

export interface IDonorStatusByCenter {
    centerId: number,
    listItems: IDonorStatus[]
}

export interface IDashRemoteStatus {
    id: number,
    description: string,
    requiresDate: boolean
}